import ContentToggler from './content-toggler-component';
import './content-toggler.scss';

const MODULE_NAME = 'app.common.content-toggler';
const module = angular.module(MODULE_NAME, [])
    .directive(ContentToggler.DIRECTIVE_NAME, ContentToggler);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/content-toggler/content-toggler-module.js